// Data Struktur Organisasi STIKES Baramuli
// Berdasarkan database stikbar_siakad.struktur_organisasi

const strukturOrganisasi = {
  pimpinan: [
    {
      id: 6,
      nama: "Drs. Yulis Tinta, M.Kes",
      jabatan: "Ketua STIKES Baramuli",
      unit_kerja: "Pimpinan",
      foto: "/api/foto/struktur/drs-yulis-tinta-m-kes/foto/foto_1768565619.png",
      urutan: 1
    },
    {
      id: 10,
      nama: "Dr. Muh. Kardi Rais, SKM, M.Kes",
      jabatan: "Wakil Ketua I",
      unit_kerja: "Bidang Akademik",
      foto: null,
      urutan: 2
    },
    {
      id: 11,
      nama: "Dr. Hj. Vonny. P, SKM, M.Kes",
      jabatan: "Wakil Ketua II",
      unit_kerja: "Bidang Keuangan & Umum",
      foto: null,
      urutan: 3
    },
    {
      id: 12,
      nama: "Abdillah, SKM, M.Kes",
      jabatan: "Wakil Ketua III",
      unit_kerja: "Bidang Kemahasiswaan",
      foto: "/api/foto/struktur/abdillah-skm-m-kes/foto/foto_1768565691.jpeg",
      urutan: 4
    }
  ],
  kepalaProgramStudi: [
    {
      id: 7,
      nama: "Siska Wijayanti Pratiwi, S.Kep, Ns, M.Kes",
      jabatan: "Ketua Program Studi",
      unit_kerja: "S1 Keperawatan",
      foto: "/api/foto/struktur/siska-wijayanti-pratiwi-s-kep-ns-m-kes/foto/foto_1768013820.png",
      urutan: 5
    },
    {
      id: 15,
      nama: "H. Muslimin, S.Kep, Ns, M.Kep",
      jabatan: "Ketua Program Studi",
      unit_kerja: "Profesi Ners",
      foto: null,
      urutan: 7
    },
    {
      id: 13,
      nama: "Nadirah, SKM, M.Kes",
      jabatan: "Ketua Program Studi",
      unit_kerja: "S1 Kesehatan Masyarakat",
      foto: null,
      urutan: 5
    }
  ],
  kepalaUnit: [
    {
      id: 16,
      nama: "Irma Aswani, SKM, M.Kes",
      jabatan: "Kepala Lembaga",
      unit_kerja: "Kerjasama & Urusan Internasional",
      foto: null,
      urutan: 8
    },
    {
      id: 17,
      nama: "Habil Harun, SKM, M.Kes",
      jabatan: "Kepala Lembaga",
      unit_kerja: "Penelitian & Pengabdian Masyarakat",
      foto: "/api/foto/struktur/habil-harun-skm-m-kes/foto/foto_1768578978.jpg",
      urutan: 9
    },
    {
      id: 18,
      nama: "Ridwan Z, SKM, M.Adm.Kes",
      jabatan: "Kepala Unit",
      unit_kerja: "Penjaminan Mutu",
      foto: "/api/foto/struktur/ridwan-z-skm-m-adm-kes/foto/foto_1768553400.jpg",
      urutan: 10
    },
    {
      id: 19,
      nama: "Taslim, SKM, M.KM",
      jabatan: "Kepala Unit",
      unit_kerja: "Laboratorium Terpadu",
      foto: null,
      urutan: 14
    },
    {
      id: 24,
      nama: "Wawan Saputra, S.Pust",
      jabatan: "Kepala Unit",
      unit_kerja: "Perpustakaan",
      foto: null,
      urutan: 19
    }
  ],
  staff: [
    {
      id: 9,
      nama: "Hidayat, SKM",
      jabatan: "Bendahara",
      unit_kerja: "Keuangan",
      foto: null,
      urutan: 7
    },
    {
      id: 20,
      nama: "Galuh Vidyaningrum, SKM",
      jabatan: "Sekretaris Program Studi",
      unit_kerja: "S1 Kesehatan Masyarakat",
      foto: "/api/foto/struktur/galuh-vidyaningrum-skm/foto/foto_1768578947.jpg",
      urutan: 15
    },
    {
      id: 21,
      nama: "Muh. Rusiqa Arif, S.Kep, Ns",
      jabatan: "Sekretaris Program Studi",
      unit_kerja: "S1 Keperawatan",
      foto: null,
      urutan: 16
    },
    {
      id: 22,
      nama: "Muh. Rudini, S.Kep, Ns, M.KM",
      jabatan: "Sekretaris Program Studi",
      unit_kerja: "Profesi Ners",
      foto: null,
      urutan: 17
    },
    {
      id: 23,
      nama: "Dian Hardianti, SKM",
      jabatan: "Kepala Biro",
      unit_kerja: "Administrasi Akademik & Kemahasiswaan",
      foto: null,
      urutan: 18
    },
    {
      id: 5,
      nama: "Ikhwan Saputra, S.Kep, Ns",
      jabatan: "Admin",
      unit_kerja: "PDDIKTI",
      foto: "/api/foto/struktur/ikhwan-saputra/foto/foto_1767984825.jpg",
      urutan: 0
    },
    {
      id: 25,
      nama: "Samsuddin, SKM",
      jabatan: "Staf",
      unit_kerja: "Perlengkapan & Umum",
      foto: null,
      urutan: 20
    },
    {
      id: 26,
      nama: "Nasrah, S.Kep, Ns",
      jabatan: "Staf",
      unit_kerja: "Laboratorium Keperawatan",
      foto: null,
      urutan: 21
    },
    {
      id: 27,
      nama: "Hamdani, S.Kep, Ns",
      jabatan: "Staf",
      unit_kerja: "Multimedia & Informatika",
      foto: null,
      urutan: 22
    },
    {
      id: 28,
      nama: "Handani Jumadi, SKM, M.Kes",
      jabatan: "Staf",
      unit_kerja: "Penelitian & Pengabdian Masyarakat",
      foto: null,
      urutan: 23
    }
  ]
};

export default strukturOrganisasi;
